import UtilServices from "@services/UtilServices";
import "./MenuInterativo.scss";
import "react-tooltip/dist/react-tooltip.css";
import { useContext, useEffect, useState } from "react";
import Input from "@components/input/Input";
import useLst from "@hooks/useLst";
import CardContato from "./cardContato/CardContato";
import MessageServices from "@services/MessageServices";
import GlobalContext from "@context/GlobalContext";
import EndPointServices from "@services/ApiServices";
import ReactLoading from "react-loading";
import Grid from "@components/grid/Grid";
import mappingColumn from "@components/grid/mappingColumn";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import usePermissoes from "@hooks/usePermissoes";

export default function MenuInterativo(props) {
  /*---Variavés Padrões--*/
  const [state, dispatch] = useContext(GlobalContext);
  const [loading, setLoading] = useState({
    ativo: false,
    idFuncionalidade: 0,
  });
  const { handlePermissoes } = usePermissoes();

  //Lista dos Menus.
  const { lstCAD_MenuInterativo } = useLst();

  /*---Variaveis Menu Suspenso--*/
  const [openMenu, setOpenMenu] = useState(false);
  const [idFuncionalidade, setIdFuncionalidade] = useState(0);

  // Contato
  const [lstContatoFilter, setlstContatoFilter] = useState([]);
  const [lstContato, setlstContato] = useState([]);

  /*---Input Pesquisa --*/
  const [pesquisar, setPesquisar] = useState("");

  //Consultas
  useEffect(() => {
    if (idFuncionalidade > 0) {
      handleConsultar();
      setPesquisar("");
    }
  }, [idFuncionalidade]);

  useEffect(() => {
    // if (props.ccCheckBox.length > 0) {
    handleConsultar();
    setPesquisar("");
    // }
  }, [props.ccCheckBox]);

  useEffect(() => {
    // if (props.ccCheckBoxSocio.length > 0) {
    handleConsultar();
    setPesquisar("");
    // }
  }, [props.ccCheckBoxSocio]);

  function handleClick(item) {
    //States Globais
    setIdFuncionalidade(item.id);

    //Se o item é exibido pelo menu suspenso.
    if (!item.menususpensolateral) {
      setOpenMenu(false);
      dispatch({
        type: "SET_ROLAGEM",
        payload: item?.ref, //Seta Rolagem
      });
    }
    if (
      item.menususpensolateral &&
      (item.id === idFuncionalidade || openMenu === false)
    ) {
      setOpenMenu(!openMenu);
    }
  }
  function handlePesquisa(e) {
    if (idFuncionalidade == 1) {
      setlstContatoFilter(UtilServices.searchLst(e, lstContato));
    }
    setPesquisar(e);
  }
  //funções para todas as ações do menuinterativo
  async function handleConsultar() {
    setLoading({ ativo: true, idFuncionalidade: idFuncionalidade });

    //Procura o endpoint da api com base no idFuncionalidade
    const consultar = lstCAD_MenuInterativo.find(
      (menu) => menu.id === idFuncionalidade,
    )?.endPoint?.consultar;

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      empresa: { CNPJ: props.ccCheckBox[0]?.CNPJ ?? null },
      socio: {
        ID_Empresa_Socio: props.ccCheckBoxSocio[0]?.ID_Empresa_Socio ?? null,
      },
    };

    try {
      if (typeof consultar === "function") {
        var retornoapi = await consultar(data);
        if (retornoapi.Success) {
          //Contato
          if (idFuncionalidade === 1) {
            let resultado = [];

            retornoapi?.BaseReturn?.LstClasse.forEach(
              ({
                nome,
                Dados,
                TpContato,
                Prioridade_Contato,
                TipoContato,
                ID_Contato,
                ContatoPessoa,
              }) => {
                // Procura no array se já existe um objeto com esse nome e ContatoPessoa
                let existente = resultado.find(
                  (item) =>
                    item.nome === nome && item.contatopessoa === ContatoPessoa,
                );

                if (!existente) {
                  existente = {
                    nome,
                    idCard: UtilServices.generateUUID(),
                    contatopessoa: ContatoPessoa,
                    Telefone: [],
                    Email: [],
                  };
                  resultado.push(existente);
                }

                if (!existente[TpContato]) {
                  existente[TpContato] = [];
                }

                existente[TpContato].push({
                  id: UtilServices.generateUUID(),
                  valor: Dados,
                  prioridade: Prioridade_Contato.toString(),
                  tipocontato: TipoContato.toString(),
                  idContato: ID_Contato,
                });
              },
            );

            // Verifica se 'Telefone' e 'Email' existem para cada item e insere arrays vazias
            Object.keys(resultado).forEach((idCard) => {
              if (!resultado[idCard]["Telefone"]) {
                resultado[idCard]["Telefone"] = [];
              }
              if (!resultado[idCard]["Email"]) {
                resultado[idCard]["Email"] = [];
              }
            });

            setlstContatoFilter(Object.values(resultado));
            setlstContato(Object.values(resultado));
          }
        }
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoading({ ativo: false, idFuncionalidade: idFuncionalidade });
  }
  async function handleEditar(param) {
    setLoading({ ativo: true, idFuncionalidade: idFuncionalidade });

    //Procura o endpoint da api com base no idFuncionalidade
    const editar = lstCAD_MenuInterativo.find(
      (menu) => menu.id === idFuncionalidade,
    )?.endPoint?.editar;

    let params = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      empresa: { CNPJ: props.ccCheckBox[0]?.CNPJ ?? null },
      socio: {
        ID_Empresa_Socio: props.ccCheckBoxSocio[0]?.ID_Empresa_Socio ?? null,
      },
      json: param,
    };

    try {
      var retornoapi = await editar(params);
      if (retornoapi.Success) {
        MessageServices.ShowSuccess("Registros atualizados com sucesso!");
      }
      handleConsultar();
    } catch (ex) {
      handleConsultar();
      console.log(ex);
    }

    setLoading({ ativo: false, idFuncionalidade: idFuncionalidade });
  }
  async function handleInativar(param) {
    setLoading({ ativo: true, idFuncionalidade: idFuncionalidade });

    //Procura o endpoint da api com base no idFuncionalidade
    const inativar = lstCAD_MenuInterativo.find(
      (menu) => menu.id === idFuncionalidade,
    )?.endPoint?.inativar;

    let params = {
      ...state.dadosusuario,
      ...param,
      ID_Empresa: props.ID_Empresa,
    };

    try {
      var retornoapi = await inativar(params);
      if (retornoapi.Success) {
      }
      handleConsultar();
    } catch (ex) {
      console.log(ex);
    }

    setLoading({ ativo: false, idFuncionalidade: idFuncionalidade });
  }
  async function handleCriar(param) {
    setLoading({ ativo: true, idFuncionalidade: idFuncionalidade });

    //Procura o endpoint da api com base no idFuncionalidade
    const criar = lstCAD_MenuInterativo.find(
      (menu) => menu.id === idFuncionalidade,
    )?.endPoint?.criar;

    let params = {
      ...state.dadosusuario,
      ...param,
      ID_Empresa: props.ID_Empresa,
    };

    try {
      var retornoapi = await criar(params);
      if (retornoapi.Success) {
      }
      handleConsultar();
    } catch (ex) {
      console.log(ex);
    }

    setLoading({ ativo: false, idFuncionalidade: idFuncionalidade });
  }
  function criar() {
    //Criar novo contato
    if (idFuncionalidade === 1) {
      const criarContato = {
        nome: "",
        idCard: UtilServices.generateUUID(),
        criar: true,
      };

      // Verifica se já existe um item com criar: true
      const existeCriarContato = lstContatoFilter.some(
        (contato) => contato.criar === true,
      );

      // Só atualiza a lista se não houver um item com criar: true
      if (!existeCriarContato) {
        setlstContatoFilter((prevState) => [criarContato, ...prevState]);
        setlstContato((prevState) => [criarContato, ...prevState]);
      } else {
        MessageServices.ShowWarning("É permitido criar um contato por vez!");
      }
    }
  }

  return (
    <div className="menuinterativo">
      {lstCAD_MenuInterativo.map((item, index) => (
        <div className="menuinterativo-a">
          <div
            className={`menuinterativo-itens ${
              //Verifica se tem permissão
              item.permissao.consultar
                ? "disabled"
                : //Verifica se tem algum socio ativo e se tem permissão
                item.id === 6 &&
                  props.ccCheckBoxSocio.length === 0 &&
                  !item.permissao.consultar
                ? "disabled"
                : //Verifica se tem alguma empresa ativa e se tem permissão
                item.id === 3 &&
                  props.ccCheckBox.length === 0 &&
                  !item.permissao.consultar
                ? "disabled"
                : ""
            }`}
            index={index}
            onClick={() => {
              //Socio
              if (
                item.id === 6 &&
                props.ccCheckBoxSocio.length === 0 &&
                !item.permissao.consultar
              ) {
                MessageServices.ShowWarning(
                  "Selecione um socio para habilitar esse campo.",
                );
              }

              //Empresa
              if (
                item.id === 3 &&
                props.ccCheckBox.length === 0 &&
                !item.permissao.consultar
              ) {
                MessageServices.ShowWarning(
                  "Selecione uma empresa para habilitar esse campo.",
                );
              }

              if (!item.permissao.consultar) {
                handleClick(item);
              } else {
                MessageServices.ShowWarning(
                  "Você não tem acesso a essa funcionalidade.",
                );
              }
            }}
            data-tooltip-id="tooltip-002"
            data-tooltip-content={item.title}
          >
            {UtilServices.stringToJsx(item.icon)}
          </div>

          {/* Menu Aberto após o click */}
          {openMenu && idFuncionalidade === item.id && (
            <div className="menususpensointerativo" style={{ top: item?.top }}>
              {/* Icone triángulo para indicar qual função está aberto */}
              <div className="menususpensointerativo-icon"></div>
              {/* Titulo , input de pesquisa e icone Criar */}
              <div className="menususpensointerativo-a">
                <div className="menususpensointerativo-title-x">
                  <i
                    className="fa-solid fa-xmark"
                    onClick={() => {
                      setOpenMenu(false);
                    }}
                    style={{ cursor: "pointer" }}
                  ></i>
                  <p>{item.title}</p>
                </div>
                <div className="menususpensointerativo-pesquisa">
                  <Input
                    theme="2"
                    icon="<i class='fa-light fa-magnifying-glass'></i>"
                    value={pesquisar}
                    onChange={(e) => {
                      handlePesquisa(e);
                    }}
                  />
                  <ButtonIcon
                    Refresh
                    titleRefresh={`Recarregar ${
                      idFuncionalidade === 1 ? "Contatos" : ""
                    }`}
                    onRefresh={() => {
                      handleConsultar();
                    }}
                    disabledRefresh={false}
                    typeRefresh={"button"}
                  />
                  <ButtonIcon
                    Criar
                    titleCriar={`Criar ${
                      idFuncionalidade === 1 ? " novo contato" : ""
                    }`}
                    onCriar={() => {
                      criar();
                    }}
                    disabledCriar={
                      !(
                        (
                          idFuncionalidade === 1 &&
                          handlePermissoes(2, "Contato", "Adicionar")
                        )
                        // || (idFuncionalidade === 2 && handlePermissoes(2, "Socio", "Adicionar"))
                      )
                    }
                    typeCriar={"button"}
                  />
                </div>
              </div>
              {/* loading menususpensointerativo */}
              {loading.ativo === true &&
              loading.idFuncionalidade === item.id ? (
                <div className="menususpensointerativo-loading">
                  <ReactLoading
                    type={"spin"}
                    color={"#c1abff"}
                    height={"30px"}
                    width={"30px"}
                    className="loading"
                  />
                </div>
              ) : (
                <>
                  {/* Contato */}
                  {item.id === 1 && (
                    <div className="menususpensointerativo-lstcontato">
                      {lstContatoFilter.map((contato, index) => (
                        <CardContato
                          key={index}
                          idCard={contato?.idCard}
                          nome={contato?.nome}
                          email={contato?.Email}
                          telefone={contato?.Telefone}
                          criar={contato?.criar}
                          contatopessoa={contato?.contatopessoa}
                          background={
                            contato?.contatopessoa === "Socio"
                              ? "var(--color-045)"
                              : ""
                          }
                          lstContato={lstContato}
                          setlstContato={setlstContato}
                          setlstContatoFilter={setlstContatoFilter}
                          lstContatoFilter={lstContatoFilter}
                          handleEditar={handleEditar}
                          setPesquisar={setPesquisar}
                          ID_Empresa_Socio={
                            props.ccCheckBoxSocio[0]?.ID_Empresa_Socio ?? null
                          }
                          CNPJ={props.ccCheckBox[0]?.CNPJ ?? null}
                        />
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

MenuInterativo.defaultProps = {
  ID_Empresa: 1,
  ccCheckBox: [],
  ccCheckBoxSocio: [],
};
